import React from 'react';
import { Avatar } from 'material-ui';
import { Form } from 'react-form';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import async from 'async';
import classNames from 'classnames';
import Translate from 'translate';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { ActionMeta, OnChangeValue } from 'react-select'
import { convertToRaw, EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import AuthService from 'services/AuthService';
import ChannelOperationService from 'services/ChannelOperationService';
import ChannelService from 'services/ChannelService';
import NetworkService from 'services/NetworkService'
import SimplePanel from 'components/HTMLElements/Panel/Simple/';
import ChangeStatusModal from 'routes/app/components/Agent/ChangeStatusModal/';
import AddImsNoAccountModal from 'routes/app/components/Agent/AddImsNoAccountModal/';
import AddImsNoAccountLECModal from 'routes/app/components/Agent/AddImsNoAccountLECModal/';
import PreviewFileModal from 'routes/app/components/Agent/PreviewFileModal/';
import SearchContactsModal from 'routes/app/components/Agent/SearchContactsFilterModal/';
import AutomaticResponsesBtn from 'routes/app/components/Agent/AutomaticResponsesBtn/';
import { FormGroup, Textarea, Checkbox, Wysiwyg, SelectCreatable } from 'components/FormElements';
import { email, required } from 'constants/InputErrors';
import { toggleAlertError, toggleLoading, updateUser } from 'stores/actions/';
import checkbox from "../../../../../assets/images/checkbox.svg";
import SendEmailModal from "../SendEmailModal";
import Util from 'util/Util';

class ChannelDetail extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      emailBCCOptions: [],
      emailCCOptions: [],

      changeStatusModalOpened: false,
      previewModalOpened: false,
      SearchContactsModalOpened: false,
      deleteModalOpened: false,
      replyConfirmationModalOpened: false,
      formData: { categories: props.data.categories, private: true },
      sendEmailModalOpened: false,
      addImsModalOpened: false,
      replyInPrivate: false
    };
    this.replyInPrivate = false;
    this.replyData = {};
    this.isBCC = false;
    this.userIsSupervisor = AuthService.getUserRole().isSupervisor;
    this.removeCategory = this.removeCategory.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.toggleChangeStatusModal = this.toggleChangeStatusModal.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
    this.toggleAddImsModal = this.toggleAddImsModal.bind( this );
    this.togglePreviewModal = this.togglePreviewModal.bind( this );
    this.autoCompleteEmailBCC = this.autoCompleteEmailBCC.bind( this );
    this.autoCompleteEmailCC = this.autoCompleteEmailCC.bind( this );
    this.toggleSearchContactsModal = this.toggleSearchContactsModal.bind( this );
    this.setCCEmail = this.setCCEmail.bind( this );
    this.closeContactList = this.closeContactList.bind( this );
    this.setEmailCC = this.setEmailCC.bind( this );
    this.setEmailBCC = this.setEmailBCC.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.data.id !== this.props.data.id ) {
      let replyInPrivate = _.get( nextProps.data, 'replyInPrivate' ) ;
      if ( (nextProps.data.lastOperation.via !== 'tw_chat' ) && (nextProps.data.lastOperation.via !== 'fb_chat')){
        replyInPrivate = false;
      }
      //console.log("recibiendo_props",replyInPrivate, '---', nextProps.data);
      this.replyInPrivate = replyInPrivate;
      this.setState( { formData: { categories: nextProps.data.categories } } )
      this.setState( { replyInPrivate } );
    }
  }

  componentDidMount() {

    let replyInPrivate = _.get( this.props.data, 'replyInPrivate' );
    if ( (this.props.data.lastOperation.via !== 'tw_chat' ) && (this.props.data.lastOperation.via !== 'fb_chat')){
      replyInPrivate = false;
    }
    this.replyInPrivate = replyInPrivate;
    if( _.get( this.props.data, 'lastOperation.socialType' ) === 'email' ) {
      const contentIframe = document.getElementById( "channelContentIframe" );
      const doc = contentIframe.contentDocument || contentIframe.contentWindow.document;
      doc.open();
      doc.write( Util.cencoLinkifyContentEmail(this.props.data.lastOperation.content) );
      doc.close();
    }
    this.setState( { replyInPrivate } );
  }

  componentDidUpdate( prevProps ) {

    if( this.props.data.id !== prevProps.data.id ) {
      let replyInPrivate = _.get( this.props.data, 'replyInPrivate' );
      if ( (this.props.data.lastOperation.via !== 'tw_chat' ) && (this.props.data.lastOperation.via !== 'fb_chat')){
        replyInPrivate = false;
      }
      this.replyInPrivate = replyInPrivate;
      if( _.get( this.props.data, 'lastOperation.socialType' ) === 'email' ) {
        const contentIframe = document.getElementById( "channelContentIframe" );
        const doc = contentIframe.contentDocument || contentIframe.contentWindow.document;
        doc.open();
        doc.write( Util.cencoLinkifyContentEmail(this.props.data.lastOperation.content) );
        doc.close();
      }
      this.setState( { replyInPrivate } );
    }
  }
  toggleAddImsModal(e) {
    this.setState( { addImsModalOpened: !this.state.addImsModalOpened } )
  }
  removeCategory() {
    this.props.toggleLoading( true );

    ChannelService.deleteChannelCategory( this.props.data.id, this.categoryToDelete )
      .then( ( response ) => {
        if( response.errors ) {
          this.props.toggleLoading( false );
          return this.props.toggleAlertError( response.errors );
        }
        this.props.onReloadData();
        if( this.props.confirmDelete ) this.setState( { deleteModalOpened: false } )
      } );
  }
  submitForm() {
    const {replyInPrivate} = this.state;


    this.props.toggleLoading( true );

    const reader = new FileReader();
    const attachments = [];
    async.eachSeries( this.replyData.attachments, ( file, nextFile ) => {
      reader.readAsDataURL( file );
      reader.onload = ( event ) => {
        attachments.push( {
          file: event.target.result,
          name: file.name
        } );
        nextFile()
      };
    }, ( error ) => {
      if( error ) return this.props.toggleAlertError( <Translate id="errorFileProcess"/> );

      delete this.replyData.categories;
      delete this.replyData.replyInPrivate;

      const data = {
        ...this.replyData,
        attachments,
        channel: this.props.data.id
      };
      //console.log(this.state,'state')
      //console.log(this.props,'props')
      if( this.props.data.lastOperation
        && ( this.props.data.lastOperation.via === 'tw_tweet_account' || this.props.data.lastOperation.via === 'tw_tweet_hashtag'
          || this.props.data.lastOperation.via === 'tw_chat' ) ) {
        data.via = this.props.data.lastOperation.via;
        if (replyInPrivate){
          data.via = 'tw_chat';
        }
        data.twReplyId = this.props.data.lastOperation.fbId;

        if( this.props.data.lastOperation.via === 'tw_tweet_account' || this.props.data.lastOperation.via === 'tw_tweet_hashtag' ) {
          data.socialParentId = this.props.data.lastOperation.socialId;
        }

        //if( data.content && this.props.data && this.props.data.type === 'twitter' ) {
        //  data.content = `${data.content} @${this.props.data.twAccount}`
        //}
        if( data.content && this.props.data && this.props.data.type === 'twitter' ) {
          data.content = `${data.content}`
        }
      }
      if( this.props.data.lastOperation && this.props.data.lastOperation.via === 'fb_feed_comment' || this.props.data.lastOperation.via === 'fb_feed' ) {
        data.socialParentId = this.props.data.lastOperation.socialId;
      }
      if( this.props.data.lastOperation
        && ( this.props.data.lastOperation.via === 'fb_chat' || this.props.data.lastOperation.via === 'fb_feed'
          || this.props.data.lastOperation.via === 'fb_feed_comment' ) ) {
        data.via = this.props.data.lastOperation.via;
        if (replyInPrivate){
          data.via = 'fb_chat';
        }
      }
      if( this.props.data.type === 'email' ) {
        data.emailAddressTo = this.props.data.email;
        data.emailAddressCc = _.map( data.emailAddressCc, 'id' ).join( ';' );
        data.emailAddressBcc = _.map( data.emailAddressBcc, 'id' ).join( ';' );
        if( data.content && this.props.data ) {
          data.content = draftToHtml( convertToRaw( data.content.getCurrentContent()) );
        }
      }
      ChannelOperationService.saveMessage( data )
        .then( ( response ) => {
          if( response.errors ) {
            this.props.toggleLoading( false );

            if (response.status === 400){
              this.toggleReplyConfirmationModal();
              this.props.onReloadClosedChannel();
            }
            return this.props.toggleAlertError( this.props.intl.formatMessage( { id: response.errors } ) );

            //return this.props.toggleAlertError( response.errors );
          }

          this.toggleReplyConfirmationModal();
          //toggleLoading( false );
          this.props.toggleAlertError( <Translate id="messageSent"/> );
          if( data.content && this.props.data && this.props.data.type === 'email' ) {
            const contentState = ContentState.createFromText( '' );
            const editorState = EditorState.push( this.getValue( 'content' ), contentState );
            this.setValue( 'content', editorState );
          }
          this.resetForm();
          this.props.toggleLoading( false );
          if (this.props.closeOnReply ){
            this.props.onReloadClosedChannel();
          } else {
            this.props.onReloadChannel(this.props.data.id);
          }
          
          

          /*ChannelService.updateChannelStatus( this.props.data.id, {
            status: 'closed',
          } ).then( ( response ) => {
            toggleLoading( false );
            if ( response.errors ) return this.props.toggleAlertError( response.errors );
            this.props.onReloadClosedChannel()
          } )*/
          

        } )
    } )
  }
  setEmailBCC = ( value ) => {
    //console.log( value );
    const formData = {
      ...this.state.formData,
      emailAddressBcc: value
    }
    this.setState( {formData})
  }
  setEmailCC = ( value ) => {
    //console.log( value );
    const formData = {
      ...this.state.formData,
      emailAddressCc: value
    }
    this.setState( {formData})
  }
  toggleChangeStatusModal( status = '' ) {
    this.statusToUpdate = status;
    this.setState( { changeStatusModalOpened: !this.state.changeStatusModalOpened } )
  }

  togglePreviewModal( file = {} ) {
    this.filePreview = file;
    this.setState( { previewModalOpened: !this.state.previewModalOpened } )
  }

  toggleSearchContactsModal = () => {
    
    this.setState( { SearchContactsModalOpened: !this.state.SearchContactsModalOpened } )
  }


  autoCompleteEmailBCC = ( value ) => {
    if (value.length > 1) { 
      let emailBCCOptions = [];
      NetworkService.searchEmailContacts( this.props.user.id ).then( ( response ) => {
        if(response.errors){
          return toggleAlertError( response.errors );
        }
        else {
          emailBCCOptions = _.map( response.data.data, item  => (  { email: item.displayName, id: item.contactAddress } ));
          this.setState( {emailBCCOptions});
        }
      } )
    }
  }
  emailBCCKeyDown = (keyD) => {
    if (keyD.keyCode === 13) {
      this.setState( {emailBCCOptions:[...this.state.emailBCCOptions, {email:keyD.target.value, id:keyD.target.value}]})
      //console.log(keyD.target.value)
    }
  }
  autoCompleteEmailCC = ( value ) => {
    if (value.length > 1) { 
      let emailCCOptions = [];
      NetworkService.searchEmailContacts( this.props.user.id ).then( ( response ) => {
        if(response.errors){
          return toggleAlertError( response.errors );
        }
        else{
          emailCCOptions = _.map( response.data.data, item  => (  { email: item.displayName, id: item.contactAddress } ));
          this.setState( {emailCCOptions});
        }
      } )
    }
  }
  emailCCKeyDown = (keyD) => {
    if (keyD.keyCode === 13) {
      this.setState( {emailCCOptions:[...this.state.emailCCOptions, {email:keyD.target.value, id:keyD.target.value}]})
      //console.log(keyD.target.value)
    }
  }
  
  setCCEmail = ( email ) => {
    //console.log('nuevo email', email);
    if ( !this.isBCC ) {
      const emails = this.state.formData.emailAddressCc || [];
      //this.setState( {emailCCOptions:[...this.state.emailCCOptions, email ]})
       emails.push( email );
       const formData = {
        ...this.state.formData,
        emailAddressCc: emails
      }
      this.setState( {formData})
    } else {
      const emails = this.state.formData.emailAddressBcc || [];
      emails.push( email );
      const formData = {
        ...this.state.formData,
        emailAddressBcc: emails
      }
      this.setState( {formData})
    }

    this.toggleSearchContactsModal();
  }

  closeContactList = ( email, emailField ) => {
    if (emailField ) {
      if ( emailField === 'emailCC' ) {
        this.isBCC = false;
        this.setCCEmail(email); 
      } else {
        this.isBCC = true;
        this.setCCEmail( email );
      } 
    }
    this.toggleSearchContactsModal();
  }
  toggleDeleteModal( categoryId ) {
    this.categoryToDelete = categoryId;

    if( this.props.confirmDelete ) return this.setState( { deleteModalOpened: !this.state.deleteModalOpened } );
    this.removeCategory()
  }

  toggleReplyConfirmationModal = ( data ) => {
    this.replyData = data;
    this.setState( { replyConfirmationModalOpened: !this.state.replyConfirmationModalOpened } );
  };

  toggleSendEmailModal = () => {
    this.setState( { sendEmailModalOpened: !this.state.sendEmailModalOpened } )
  };
  handleReplyInPrivate = (via) => {
    const {replyInPrivate} = this.state;
    if ((via !== 'fb_chat') && (via !== 'tw_chat')){
      this.replyInPrivate = !replyInPrivate;
      this.setState( previousState => ( { replyInPrivate: !previousState.replyInPrivate } ) );
      
    }
  };
  render() {
    const { addImsModalOpened, replyInPrivate, emailBCCOptions, emailCCOptions } = this.state;
    const { data, options, onAssign, onReloadData, confirmDelete, onReloadClosedChannel, networkSettings, intl, activeAccount, externalCustomer, user } = this.props;
    const lastOperation = _.get( data, 'lastOperation', {} );
    const channelNotEnabled = data.status !== 'open' && data.status !== 'in_progress' && data.status !== 'return';
    const channelType = _.get( data, 'type' );
    
    const twitterLimit = networkSettings.twitterLimit !== -1 ?
      ( data.twAccount && ( lastOperation.via === 'tw_tweet_account' || lastOperation.via === 'tw_tweet_hashtag' ) )
        ? networkSettings.twitterLimit - data.twAccount.length - 1 : networkSettings.twitterLimit : null;
        const componentDecorator = (href, text, key) => (
          <a href={href} key={key} target="_blank" rel="noopener noreferrer">
              {text}
          </a>
      );
    return (
      <Form defaultValues={this.state.formData}
            onSubmit={this.toggleReplyConfirmationModal}
            validate={( values ) => {
              return {
                content: channelType === 'email' ? values.content ? values.content.getCurrentContent().hasText() ? null : 'This field is required'
                  : 'This field is required'
                  : required( values.content ),
                emailAddressBcc: channelType === 'email' ? _.find( values.emailAddressBcc, item => !!email( item.id ) ) ? 'There are no valid emails' : null : null,
                emailAddressCc: channelType === 'email' ? _.find( values.emailAddressCc, item => !!email( item.id ) ) ? 'There are no valid emails' : null : null,
              }
            }}
      >
        {( { getValue, removeValue, resetForm, setValue, submitForm } ) => {
          this.resetForm = resetForm;
          this.getValue = getValue;
          this.setValue = setValue;
          return (
            <form onSubmit={submitForm}>
              <SimplePanel className="m-0 no-shadow border-y border-gray-1" contentClassName="box-center py-2 px-3">
              { channelType === 'email' &&
                <div className="row">
                  <div className="col-md">
                    <div className='m-0 color-gray-2' style={{lineHeight:'24px'}}>
                      <span className="font-weight-medium">{intl.formatMessage( { id: "subject" } )} : </span>
                        { _.get( data, 'snippet' ) }
                    </div>
                  </div>
                </div>
                }
                <div className="row align-items-center">
                  <div className="col-md">
                    {_.get( data, 'lastOperation.socialCreateTime' ) &&
                    <div className="m-0 color-gray-2" style={{lineHeight:'24px'}}>
                      <span className="font-weight-medium">{intl.formatMessage( { id: "Reportedon" } )}  : </span>
                      {moment( _.get( data, 'lastOperation.socialCreateTime' ) ).format( 'DD/MM/YYYY h:mm A' )}

                      {_.get( data, 'tone.tone' ) && _.get( data, 'tone.tone' ) ==='HIGH' &&
                        <img data-tip={intl.formatMessage( { id: "tone" } )} style={{paddingLeft:'5px'}} alt={intl.formatMessage( { id: "tone" } )} className="" width={20} src={ 'assets/images/icons/thumb-up.png' }/>
                      }

                      {_.get( data, 'tone.tone' ) && _.get( data, 'tone.tone' ) ==='LOW' &&
                        <img data-tip={intl.formatMessage( { id: "tone" } )} style={{paddingLeft:'5px'}} alt={intl.formatMessage( { id: "tone" } )} className="" width={20} src={ 'assets/images/icons/thumb-down.png' }/>
                      }

                      {_.get( data, 'tone.tone' ) && _.get( data, 'tone.tone' ) ==='NEUTRAL' &&
                        <img data-tip={intl.formatMessage( { id: "tone" } )} style={{paddingLeft:'5px'}} alt={intl.formatMessage( { id: "tone" } )} className="" width={20} src={ 'assets/images/icons/point-at.png' }/>
                      }
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                      {data.important &&
                         <i data-tip={intl.formatMessage( { id: "important" } )}  className="fa fa-exclamation p-1 mr-2 color-danger"/>
                      }
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </div>
                    }
                  </div>
                  <div className="col-md-auto">
                    {data.lastOperation && (data.lastOperation.socialType === 'email' || data.lastOperation.private ||  data.lastOperation.via ==='tw_chat' || data.lastOperation.via ==='fb_chat' ) &&
                      <span key={1989898} className="badge badge-pill badge-primary font-weight-normal text-small mx-1">
                        {intl.formatMessage( { id: "Private" } ) }
                      </span>
                    }
                  </div>
                </div>
                
              <div className="row">
                  <div className="col-md">
                    {_.map( data.categories, ( category, index ) =>
                      <span key={index*33}
                            className="badge badge-pill badge-secondary bg-gray-3 font-weight-normal text-small mx-1">
                        <span key={index*34} className="d-flex align-items-center">
                          {category.category} 
                          {this.userIsSupervisor && data.status !== 'closed' &&
                          <i key={index*35} className="icon-close pointer ml-2"
                             style={{ fontSize: 8 }}
                             onClick={() => this.toggleDeleteModal( category.id )}/>
                          }
                        </span>
                    </span> )
                    }

                    {_.get( data, 'service.service' ) &&
                      <span
                            className="badge badge-pill badge-secondary font-weight-normal text-small mx-1">
                        <span className="d-flex align-items-center">
                          {_.get( data, 'service.service' ) }

                        </span>
                    </span>
                    }
                  </div>
                  <div className="col-md-auto">
                    <span>
                      <i data-tip={intl.formatMessage( { id: "forwardEmail" } )}
                         className={classNames( 'fa fa-share pointer p-2', {
                           'color-purple': !channelNotEnabled,
                           'color-gray-3': channelNotEnabled
                         } )}
                         onClick={channelNotEnabled ? () => {} : this.toggleSendEmailModal}/>
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </span>
                    {( data.status === 'created' || data.status === 'return' || data.status === 'assigned' || data.status === 'closed' ) &&
                    <i className="fa fa-play pointer color-purple p-2"
                       style={{ fontSize: 18 }}
                       onClick={() => this.toggleChangeStatusModal( 'open' )}>
                    </i>
                    }
                    {this.userIsSupervisor && data.status === 'open' &&
                    <span>
                      <i data-tip={intl.formatMessage( { id: "UnassignCase" } )}
                         className="icon-reply pointer color-purple p-2 text-16"
                         onClick={() => this.toggleChangeStatusModal( 'return' )}/>
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </span>
                    }
                    {( data.status === 'open' || data.status === 'in_progress' ) &&
                    <span>
                      <i className="icon-check pointer color-purple p-2 text-16"
                         data-tip={intl.formatMessage( { id: "ResolveCase" } )}
                         onClick={() => this.toggleChangeStatusModal( 'closed' )}
                      />
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </span>
                    }
                    {this.userIsSupervisor && data.status !== 'closed' &&
                    <span>
                      <i data-tip={intl.formatMessage( { id: "AssignCase" } )}
                         className="icon-add-user pointer color-purple p-1 text-16"
                         onClick={onAssign}>
                      </i>
                      <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    </span>
                    }
                  </div>
                </div>

                <hr/>

                <iframe id="channelContentIframe" className={classNames('w-100 border-0', {
                  'd-none': !data.lastOperation || data.lastOperation.socialType !== 'email'
                } )}/>
                {!!data.lastOperation &&
                
                  <p className={classNames( {
                    'd-none': !data.lastOperation || data.lastOperation.socialType === 'email'
                  } )}>
                    {Util.cencoLinkifyContent(data.lastOperation.content)}
                    
                  </p>
                }

                {lastOperation &&
                _.map( lastOperation.attachments, ( file, index ) => {
                    return <div key={index}
                                className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                      <a href={file.webPathFileName} className="text-dark font-weight-normal"
                         target="_blank">{file.name}</a>
                    </div>
                  }
                )}

                <hr/>
                {((channelType !== 'phone' &&  channelType !== 'walk_in') || lastOperation.via === 'phone_sms') &&
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    {channelType !== 'twitter' && (
                      <Dropzone
                        className={classNames('d-inline', { disabled: channelNotEnabled || channelType === 'twitter' })}
                        accept="application/pdf, .doc, .docx, .xlsx, .xls, image/*" disabled={channelNotEnabled || channelType === 'twitter'}
                        maxSize={5000000}
                        onDrop={(files) => setValue('attachments', getValue('attachments') ? getValue('attachments').concat(...files) : files)}>
                        <i className="fa fa-paperclip mr-1" />
                        <span className="color-gray-4 pointer font-weight-light"><Translate id="AttachFile" /></span>
                      </Dropzone>
                    )}    

                    {channelType === 'twitter' && twitterLimit &&
                    <span className="ml-3 color-gray-4">
                      {getValue( 'content' )
                        ? twitterLimit - getValue( 'content' ).length : twitterLimit}
                        {' '}
                        <Translate id="remainingCharacters"/>
                    </span>
                    }

                    {channelType === 'phone' && networkSettings.smsLimit !== -1  &&
                    <span className="ml-3 color-gray-4">
                      {getValue( 'content' )
                        ? networkSettings.smsLimit - getValue( 'content' ).length : networkSettings.smsLimit }
                        {' '}
                        <Translate id="remainingCharacters"/>
                    </span>
                    }
                    
                    {channelType === 'facebook' && networkSettings.facebookLimit !== -1 &&
                    <span className="ml-3 color-gray-4">
                      {getValue( 'content' )
                        ? networkSettings.facebookLimit - getValue( 'content' ).length : networkSettings.facebookLimit}
                      {' '}
                      <Translate id="remainingCharacters"/>
                    </span>
                    }
                    {/*{channelType === 'email' && networkSettings.emailLimit !== -1 &&
                    <span className="ml-3">
                      {getValue( 'content' )
                        ? networkSettings.emailLimit - getValue( 'content' ).length : networkSettings.emailLimit} <Translate id="remainingCharacters"/>
                    </span>
                    }*/}
                  </div>

                  <AutomaticResponsesBtn options={_.filter( options.responses, item => (!item.type || item.type === 'social') 
                                                && ( data && data.categories && item && item.category && item.category.id && _.find(data.categories,  {id: item.category.id} )  !== undefined  || (data.categories.length === 0  || !item.category) ) )}
                                         disabled={channelNotEnabled}
                                         onClickResponse={( value ) => {
                                           if( channelType === 'email' ) {
                                             this.setValue( 'content', EditorState.createWithContent( ContentState.createFromText( value ) ) );
                                           } else {
                                             setValue( 'content', value )
                                           }
                                         }}
                  />
                </div>
                }

                {_.map( getValue( 'attachments' ), ( file, index ) => {
                    return <div key={index}
                                className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                      <span key={index*87} className={'icon-link pointer color-purple'} onClick={() => this.togglePreviewModal( file ) }> {file.name} </span>
                      <i className="fa icon-close pointer"
                         onClick={() => removeValue( 'attachments', index )}/>
                    </div>
                  }
                )}

                {channelType === 'email' &&
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    {externalCustomer !== 'kplc' &&
                      <label>CC</label>
                    }
                    {externalCustomer === 'kplc' &&
                      <label>CC <span className="fa fa-list pointer" onClick={() => { this.isBCC = false; this.toggleSearchContactsModal() }}></span> </label>
                    } 
                    { ((externalCustomer !== 'kplc') || ( externalCustomer === 'kplc' &&  ( !user.emailUsername || user.emailUsername === '') )) &&

                      <SelectCreatable field="emailAddressCc" className="form-control" multi
                                     selectDisabled
                                     placeholder=""
                                     labelKey="email"/>
                    }
                    { (externalCustomer === 'kplc' && user.emailUsername && user.emailUsername !== '' ) &&
                      <SelectCreatable field="emailAddressCc" className="form-control" multi
                                      placeholder=""
                                      onInputChange={this.autoCompleteEmailCC}
                                      onInputKeyDown={this.emailCCKeyDown}
                                      options={emailCCOptions}
                                      onChange={this.setEmailCC}
                                      labelKey="email"/>
                    }
                    
                  </FormGroup>

                  <FormGroup containerClass="col-md-6">
                    {externalCustomer !== 'kplc' &&
                    <label>BCC</label>
                    }
                    {externalCustomer === 'kplc' &&
                    <label>BCC <span className="fa fa-list pointer" onClick={() => { this.isBCC = true; this.toggleSearchContactsModal() }}></span> </label>
                    } 
                    
                    { ((externalCustomer !== 'kplc') || ( externalCustomer === 'kplc' &&  ( !user.emailUsername || user.emailUsername === '') )) &&
                      <SelectCreatable field="emailAddressBcc" className="form-control" multi
                                    selectDisabled
                                    placeholder=""
                                    labelKey="email"/>
                    }
                    { (externalCustomer === 'kplc' && user.emailUsername && user.emailUsername !== '' ) &&
                      <SelectCreatable field="emailAddressBcc" className="form-control" multi
                                     placeholder=""
                                     onInputChange={this.autoCompleteEmailBCC}
                                     onInputKeyDown={this.emailBCCKeyDown}
                                     options={emailBCCOptions}
                                     onChange={this.setEmailBCC}
                                     labelKey="email"/>
                    }
                  </FormGroup>
                </div>
                }
                {lastOperation && (channelType !== 'email') && (channelType !== 'twitter') &&   (lastOperation.via === 'tw_chat' || lastOperation.via === 'fb_chat' || data.replyInPrivate === true) &&
                 
                 <FormGroup>
                    <Checkbox field="replyInPrivate" label={<Translate id="replyInPrivate"/>}
                              checked={ replyInPrivate || false }
                              onClick={( event ) => {
                                event.stopPropagation();
                                this.handleReplyInPrivate( lastOperation.via )
                              }}
                              uncheckedIcon={<div style={{paddingLeft: 3}}><img src={checkbox}/></div>}
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>
                }
                <FormGroup>
                  {channelType === 'phone' && lastOperation.via === 'phone_sms' &&
                  <Textarea field="content" className="form-control" rows={8}
                            disabled={channelNotEnabled}
                            maxLength={networkSettings.smsLimit !== -1 ? networkSettings.smsLimit : 60}/>
                  }
                  {channelType === 'twitter' &&
                  <Textarea field="content" className="form-control" rows={8}
                            disabled={channelNotEnabled}
                            maxLength={twitterLimit}/>
                  }
                  {channelType === 'facebook' &&
                  <Textarea field="content" className="form-control" rows={8}
                            disabled={channelNotEnabled}
                            maxLength={networkSettings.facebookLimit !== -1 ? networkSettings.facebookLimit : null}/>
                  }
                  {channelType === 'email' &&
                  <Wysiwyg field="content" readOnly={channelNotEnabled}/>
                  }
                </FormGroup>

                {channelType !== 'phone' && channelType !== 'walk_in' &&
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      className="btn btn-info px-3"
                      disabled={channelNotEnabled || data.type === 'phone'}
                      onClick={this.toggleAddImsModal}
                    >
                      <i className="fa fa-plus mr-1"/>
                      <Translate id="addImsCase"/>
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button className="btn btn-info px-3" disabled={channelNotEnabled || data.type === 'phone' }>
                      <i className="fa fa-reply mr-1"/>
                      <Translate id="reply"/>
                    </button>
                  </div>
                </div>
                }

                {channelType === 'phone' &&
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      className="btn btn-info px-3"
                      disabled={channelNotEnabled }
                      onClick={this.toggleAddImsModal}
                    >
                      <i className="fa fa-plus mr-1"/>
                      <Translate id="addImsCase"/>
                    </button>
                  </div>
                  {lastOperation.via === 'phone_sms' &&
                  <div className="col-md-6 text-right">
                    <button className="btn btn-info px-3" disabled={channelNotEnabled}>
                      <i className="fa fa-reply mr-1"/>
                      <Translate id="reply"/>
                    </button>
                  </div>
                  }
                </div>
                }

                {channelType === 'walk_in' &&
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      className="btn btn-info px-3"
                      disabled={channelNotEnabled }
                      onClick={this.toggleAddImsModal}
                    >
                      <i className="fa fa-plus mr-1"/>
                      <Translate id="addImsCase"/>
                    </button>
                  </div>
                </div>
                }

                {externalCustomer !== 'lec' && externalCustomer !== 'escom' &&
                <AddImsNoAccountModal channel={data}
                      activeAccount={activeAccount}
                      open={addImsModalOpened}
                      onClose={this.toggleAddImsModal}
                      onReloadData={onReloadData}
                />
                }

                {externalCustomer === 'lec' &&
                <AddImsNoAccountLECModal channel={data}
                      activeAccount={activeAccount}
                      open={addImsModalOpened}
                      onClose={this.toggleAddImsModal}
                      onReloadData={onReloadData}
                />
                }
                {externalCustomer === 'escom' &&
                <AddImsNoAccountLECModal channel={data}
                      activeAccount={activeAccount}
                      open={addImsModalOpened}
                      onClose={this.toggleAddImsModal}
                      onReloadData={onReloadData}
                />
                }
                <hr/>

                {_.get(data, 'lastAgent') ?
                <div className="d-flex justify-content-between font-italic">
                  <span>{<Translate id="LastAction"/>}: {`${data.lastAgent.name} ${data.lastAgent.lastname || ''}`}</span>
                </div> : null }
              </SimplePanel>

              <ChangeStatusModal channel={data}
                                 data={{ status: this.statusToUpdate }}
                                 open={this.state.changeStatusModalOpened}
                                 onClose={this.toggleChangeStatusModal}
                                 onReloadData={onReloadData}
                                 tones={options.tones}
                                 onReloadClosedChannel={onReloadClosedChannel}
                                 onReloadChannel={this.props.onReloadChannel}
              />

              <SendEmailModal open={this.state.sendEmailModalOpened}
                              onClose={this.toggleSendEmailModal}
                              channel={data}
                              activeAccount={activeAccount}
                              content={
                                data.type==='email' ?
                                `<div>Created at: ${_.get(data, 'lastOperation.socialCreateTime')}<br>From: ${_.get(data, 'email')}<br>To: ${_.get(data, 'lastOperation.direction')}<br>Subject: ${_.get(data, 'lastOperation.subject')}<br><br>${_.get(data, 'lastOperation.content')}</div>`
                                :
                                `<div>Created at: ${_.get(data, 'lastOperation.socialCreateTime')}<br>From: ${data.name}<br>To: ${_.get(data, 'lastOperation.direction')}<br>Channel: ${_.get(data, 'lastOperation.socialType')}<br><br>${_.get(data, 'lastOperation.content')}</div>`



                              }
              />


              {confirmDelete &&
              <DeleteModal label={<Translate id="youSureDeleteCategory"/>}
                           onConfirm={this.removeCategory}
                           opened={this.state.deleteModalOpened}
                           onToggle={this.toggleDeleteModal}
              />
              }

              <DeleteModal label={<Translate id="youSureReplyChannel"/>}
                           onConfirm={this.submitForm}
                           opened={this.state.replyConfirmationModalOpened}
                           onToggle={this.toggleReplyConfirmationModal}
              />

              <PreviewFileModal  data={this.filePreview}
                                 open={this.state.previewModalOpened}
                                 onClose={this.togglePreviewModal}
              />
              <SearchContactsModal 
                                 open={this.state.SearchContactsModalOpened}
                                 user={user}
                                 onClose={this.closeContactList}
                                 emailField={this.isBCC ? 'emailBCC' : 'emailCC'}
              />
            </form>
          )
        }}

      </Form>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  confirmDelete: state.user.beforeDelete,
  closeOnReply: state.settings.closeOnReply,
  networkSettings: state.settings.networkSettings,
  externalCustomer: state.settings.externalCustomer,
  user: state.user
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ChannelDetail ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChannelDetail/index.js